import generateReport from "../../services/AxiosReportService";
import api from "../../services/AxiosService"

export const getAllBranches = () => {
    return api("get", "api/branches/list", "", null);
};

export const getAllBranchesByDistrictName = (data) => {
    return api("get", "api/branch-by-district-name",data, null);
}

export const getAllDistrict = () => {
    return api("get", "api/district-branch/list", "", null);
};

export const getAllDepositsProducts = () => {
    return api("get", "api/products/deposits", "", null);
};

export const getAllLoansProducts = () => {
    return api("get", "api/products/loans", "", null);
};

export const getAllWasams = () => {
    return api("get", "api/wasmas/list", "", null);
};

export const getAllBranch = () => {
    return api("get", "api/branch/list", "", null);
};

export const getAllBranchByDistrictId = (data) => {
    return api("post", "api/branch-by-district-id/", "", data);
};

export const getAllWasmaByBranchIds = (branchIds) => {
    return api("post", "api/wasmas/by-branches","", branchIds);
};


export const getAllDistrictList = () => {
    return api("get", "api/district/all-list", "", null);
};

export const generateDistrictDepsitReport = (data) => {
    return generateReport("post", "api/account/monthly/generate", "", data);
};

export const generateDistrictWiseCountReport = (data) => {
    return generateReport("post", "api/district-count/generate", "", data)

};

export const generateSocialBenefitReport = (data) => {
    return api("post", "api/book-entry-details/social-benefits-account/generate", "", data)

};

export const generateinvestmentSummaryReportDistrictWise = (data) => {
    return generateReport("post", "api/other-bank/district-wise/generate", "", data)
};

export const generateinvestmentSummaryReportIslandWise = (data) => {
    return generateReport("post", "api/other-bank/island-wise/generate", "", data)
};

export const generateSamurthiBankDetailsReport = (data) => {
    return generateReport("post", "api/customer/details/generate", "", data)
};

export const getSamurthiBankDetailsData = (data) => {
    return api("post", "api/customer/details/generate", "", { ...data, isExcel: true });
};

export const generateSocialBenefitAccountReportDistrictVise = (data) => {
    return generateReport("post", "api/book-entry-details/district-summary/generate", "", data)
};

export const generateOtherBankBranchWise = (data) => {
    return generateReport("post", "api/other-bank/branch-wise/generate", "", data)
};

export const generateIncomeReportBranchSummary = (data) => {
    return generateReport("post", "api/sub-headers/income-report", "", data)
};
export const generateIncomeStatementReportDistrictSummary = (data) => {
    return generateReport("post", "api/sub-headers/income-report/district", "", data)
};


export const generateStatementReportBranchSummary = (data) => {
    return generateReport("post", "api/bs-sub-headers/statement-report", "", data)
};

export const getReportDetails = () => {
    return api("get", "api/pnl-report/reports", "", null)
};

export const getBsReportDetails = () => {
    return api("get", "api/bs-format/bs-reports", "", null)
};

export const generatebalanceCheckDeposit = (data) => {
    return generateReport("post", "api/account/balance-check-certificate", "", data)
};

export const generatebalanceCheckLoan = (data) => {
    return generateReport("post", "api/loan/balance-check-certificate", "", data)
};

export const getDailyWorkDetails = (data) => {
    return api("post", "api/book-entry-details/daily-work-details", "", data)
};
export const getDailyWorkCashTransaction = (data) => {
    return api("post", "api/book-entry-details/cash-transaction-details", "", data)
};

export const getDailyWorkNonCashTransaction = (data) => {
    return api("post", "api/book-entry-details/non-cash-transaction-details", "", data)
};

export const getDivAreaBranches = () => {
    return api("get", "api/div-branch/list",null);
}

export const getBranchesByDivArea = (divAId) => {
    return api("get", `api/branch-by-diva-id/${divAId}`, null);
};


export const getAllUsersByBranch = (data) => {
    return api("get", "api/branch/users",data,null);
}

export const getAllDistributionNameByBranch = (data) => {
    return api("get", "api/branch/common-distribution-list",data,null);
}

export const getAllDistributionList = (data) => {
    return generateReport("post", "api/branch/generate/common-distribution-list","",data);
}

export const getAllDailyTransactions = (data) => {
    return api("post", "api/transaction/daily-transaction","",data);
}

export const generateInvestmentReviewReport = (data) => {
    return api("post", "api/other-bank/investment-review-report","",data);
}

export const generateInvestmentTrailBalance = (data) => {
    return generateReport("post", "api/other-bank/investment-trail-balance","",data);
}

export const pnlNotesReport = (data) => {
    return generateReport("post","api/pnl-report/pnl-notes","",data);
}

export const bsNotesReport = (data) => {
    return generateReport("post","api/bs-format/bs-notes","",data);
}

export const dailyWorkDetailsReport=(data=>{
    return generateReport("post","api/book-entry-details/daily-work-details-report","",data)
})

export const bsNotesBranchWiseReport = (data) => {
    return api("post","api/bs-format/excel/bs-notes","",data);
}

export const pnlNotesBranchWiseReport = (data) => {
    return api("post","api/pnl-report/excel/pnl-notes","",data);
}

//customer-details-report
export const customerDetailsReportExcel = (data) => {
    return api("post", "api/customer-details","",data);
}

export const customerDetailsReportPdf = (data) => {
    return generateReport("post", "api/customer-details","",data);
}

export const getAllCustomers = (data) => {
    return api("get", "api/customer/list","",data);
}

export const searchCustomerNames = (data) => {
    return api("post", "api/customer/search","",data);
}

export const getDistrictDivisionalBranchDetails = () => {
    return api("get","api/district-divisional-branch","",null)
}

export const getCommonDistributionDetails = (data) => {
    return api("post","api/common-distribution","",data)
}

export const getCommonDistributionListByBranchList  = (data) => {
    return api("post","api/branch/common-distribution-list","",data)
}

export const getBranchWiseInvestmentSummary = (data) => {
    return api("post", "api/other-bank/branch-wise-investment-summary", "", data);
}

export const generateUserActivityLogReport = (data) => {
    return api("post", "activity-log/user-activity-log", "", data);
}

export const generateUserLoginDetailsReport = (data) => {
    return api("post", "login-details/user-login-details", "", data);
}

export const getMonitorCustomerDetailsReport = (data) => {
    return api("post", "api/monitor-customer-details", "", data);
}

export const getCustomerInquiryReport = (data) => {
    return api("post", "api/customer-inquiry", "", data);
};

export const getCustomerInquirySummary = (data) => {
    return api("post", "api/customer-inquiry", "", data);
};
